import * as z from "zod";

/** `page` (from 1) and `pageSize` of a list input, from the query string; the limits are the list's own. */
export function pagination({ defaultSize, maxSize }: { defaultSize: number; maxSize: number }) {
  return {
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(maxSize).default(defaultSize),
  };
}
